import { Controller } from "@hotwired/stimulus";
import Swiper from "swiper";
import {
  A11y,
  Autoplay,
} from "swiper/modules";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { initializeLottieAnimations } from "frontend/javascript/lib/lottie.js";
import "swiper/css";

// Register ScrollTrigger plugin
gsap.registerPlugin(ScrollTrigger);

export default class extends Controller {
  static targets = ["carousel", "track", "slide", "lottie"];

  connect() {
    this._initializeSwiper();
    this.lottieCleanup = initializeLottieAnimations(this.lottieTargets, "Header");
  }

  disconnect() {
    if (this.swiper) {
      this.swiper.destroy();
      this.swiper = undefined;
    }
    this.lottieCleanup?.();
  }

  _initializeSwiper() {
    if (this.slideTargets.length < 2) return;

    this.swiper = new Swiper(this.carouselTarget, {
      modules: [A11y, Autoplay],
      ...this.defaultOptions,
    });
    window.headerTextCarousel = this.swiper;
  }

  get defaultOptions() {
    return {
      loop: true,
      direction: "vertical",
      allowTouchMove: false,
      speed: 1000,
      ...(!this._hasConnectedCarousel() && {
        autoplay: {
          delay: 4000,
          disableOnInteraction: false,
          waitForTransition: false,
          stopOnLastSlide: false,
        },
      }),
    };
  }

  // private

  _hasConnectedCarousel() {
    return document.querySelector("header [data-controller='carousel']");
  }
}
